module.exports = __webpack_public_path__ + "img/patrimony-explained.58a2dfaf.svg";